import { createContext, useContext, useEffect, useState } from 'react';
import messages from '../../containers/Tasks/CompanyManagement/PDPClass/Messages';
import { useLocation, useNavigate } from '@reach/router';

interface IContext {
  isDirty?: boolean | undefined;
  handleChangeDirty?: (status: boolean) => void;
  notifyUnsavedChanges?: () => boolean;
  navigateWithConfirmation?: (path: string, e?: Event) => void;
}

const cntx = createContext<IContext>({});

export const SafeNavigateProvider = (props: any) => {
  const [isDirty, setIsDirty] = useState(false);

  const handleChangeDirty = (status: boolean) => {
    setIsDirty(status);
  };

  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithConfirmation = (path: string, e?: Event) => {
    if (isDirty) {
      const result = confirm(messages.changesAreNotSaved);
      if (result) {
        setIsDirty(false);
        navigate(path);
      } else {
        e?.preventDefault();
      }
    } else {
      navigate(path);
    }
  };

  const notifyUnsavedChanges = () => {
    if (isDirty) {
      const result = confirm(messages.changesAreNotSaved);
      if (result) {
        setIsDirty(false);
        return true;
      } else return false;
    }
    return true;
  };

  useEffect(() => {
    if (isDirty) {
      setIsDirty(false);
    }
  }, [location.pathname]);

  return (
    <cntx.Provider
      value={{
        isDirty,
        handleChangeDirty,
        notifyUnsavedChanges,
        navigateWithConfirmation,
      }}
    >
      {props.children}
    </cntx.Provider>
  );
};

const useSafeNavigate = () => {
  const safeNavigateContext = useContext(cntx);
  return safeNavigateContext;
};

export default SafeNavigateProvider;
export { useSafeNavigate };
